import { getGrabTodoList, rejectOwner, setOwner, undoTodo } from '@/api/todo';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;
export default class ReleaseTodoList {
  public list: IGrabTodoInfo[] = [];
  public async requestGrabTodoList() {
    try {
      const res = await getGrabTodoList();
      this.list = res.data;
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async requestAgreeOwner(todo: IGrabTodoInfo) {
    try {
      const {id, owner} = todo;
      const res = await setOwner({
        todoId: id,
        staffId: owner,
        comment: null,
        isAgree: true,
      });
      this.removeTodo(id);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async requestRefuseOwner(params: ITodo.IRequest.IRejectGrabTodoOwner) {
    try {
      const res = await rejectOwner(params);
      this.updateTodo({id: params.todoId, owner: null, ownerName: ''});
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async requestUndoTodo(todoId: string) {
    try {
      const res = await undoTodo(todoId);
      this.removeTodo(todoId);
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public updateTodo(newTodo: Partial<IGrabTodoInfo>) {
    const index = this.list.findIndex((todo) => todo.id === newTodo.id);
    if (index >= 0) {
      this.list[index] = {...this.list[index], ...newTodo};
    }
  }
  public removeTodo(todoId: string) {
    this.list = this.list.filter((todo) => todo.id !== todoId);
  }
}
export const releaseTodoListInstance = new ReleaseTodoList();
